<template>
  <w-modal
    v-model="show"
    close-button="Anuluj"
    :submit-button="submitButtonTitle"
    :close-on-submit="false"
    :hide-on-overlay="false"
    :hide-on-esc="false"
    :title="title"
    @close="close"
    @submit="submit"
  >
    <div class="warningText">
      <i :class="iconClass" />

      <br />

      <h1>{{ textHeader }}</h1>

      <br />

      <h3>{{ text }}</h3>
    </div>
  </w-modal>
</template>

<script>
import { modalMixin } from '@/mixins/modal';

// @vuese
// Modal potwierdzania
// @group Modals
export default {
  mixins: [modalMixin],
  props: {
    // Tytuł modala
    title: { type: String, required: false },
    // Tekst do wyświetlenia
    text: { type: String, required: true },
    // Nagłówek tekstu
    textHeader: { type: String, required: false, default: 'Uwaga' },
    // Klasa css ikony
    iconClass: { type: String, required: false, default: 'fal fa-info-circle warningIcon' },
    // Tekst przycisku potwierdzenia
    submitButtonTitle: { type: String, required: false, default: 'Potwierdź' },
    // Data do przesłania przy potwierdzeniu
    submitData: { type: Object, required: false }
  },
  methods: {
    // @vuese
    // Emituje komunikat o potwierdzeniu
    submit() {
      this.$emit('submit', this.submitData);
      this.close();
    }
  }
};
</script>

<style>
.warningIcon {
  font-size: 7em;
}

.warningText {
  text-align: center;
}
</style>
